import { useEffect, useState } from "react";

export default function BackTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed right-5 bottom-6 z-40 inline-flex w-11 h-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-primary-500 shadow-soft transition-colors"
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}